import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentService } from 'src/app/services/document/document.service';
import { UserData } from '../../documents/add-useful-document/add-useful-document.component';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { AppService } from 'src/app/services/app/app.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { Validators } from '@angular/forms';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-assign-users',
  templateUrl: './assign-users.component.html',
  styleUrls: ['./assign-users.component.scss']
})
export class AssignUsersComponent {

  public assignForm!: FormGroup;
  public userType: string = 'department';
  public userData!: UserData;
  public empArr: any[] = []
  public managerArr: any[] = []
  allManagers: any[] = [];
  allEmployees: any[] = [];

  managerItem = {
    arr: this.managerArr,
    searchText: '',
    filter_value: 'ma_i',
    nameFields: ['f_n', 'l_n'] // For full name
  };

  employeeItem = {
    arr: this.empArr,
    searchText: '',
    filter_value: 'em_i',
    nameFields: ['f_n', 'l_n']
  };

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private docService: DocumentService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<AssignUsersComponent>,
    private userManagementService: UserManagementService) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.assignForm = this.fb.group({
      'all_user': [false],
      ma_i: [[], Validators.required],
      em_i: [[], Validators.required]
    })

    this.getList()
  }
  onUserType(value: string) {
    this.userType = value
  }


  getList() {
    this.spinner.show();
    this.docService.getAllUserListing().subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.managerArr = success.data.manager
          this.empArr = success.data.employee
          this.empArr.map(item => item["name"] = item["f_n"] + ' ' + item["l_n"])
          this.managerArr.map(item => item["name"] = item["f_n"] + ' ' + item["l_n"])

          // Store all manager IDs in the allManagers array
          this.allManagers = this.managerArr.map(manager => manager.ma_i);

          // Store all employee IDs in the allEmployees array
          this.allEmployees = this.empArr.map(employee => employee.em_i);


          this.managerItem = {
            arr: this.managerArr,
            searchText: '',
            filter_value: 'ma_i',
            nameFields: ['f_n', 'l_n']
          };

          this.employeeItem = {
            arr: this.empArr,
            searchText: '',
            filter_value: 'em_i',
            nameFields: ['f_n', 'l_n']
          };
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  onAllUserChange() {
    if (this.dialogData == "manager") {

      if (this.assignForm.value.all_user) {


        this.assignForm.get('em_i')?.setValue(this.allEmployees);

        // Remove 'required' validation
        this.assignForm.get('em_i')?.clearValidators();
        this.assignForm.get('em_i')?.updateValueAndValidity();
      } else {
        this.assignForm.get('em_i')?.setValue([]);

        // Add 'required' validation back
        this.assignForm.get('em_i')?.setValidators(Validators.required);
        this.assignForm.get('em_i')?.updateValueAndValidity();
      }
    }

    if (this.dialogData == "employee") {
      if (this.assignForm.value.all_user) {
        this.assignForm.get('ma_i')?.setValue(this.allManagers);

        // Remove 'required' validation
        this.assignForm.get('ma_i')?.clearValidators();
        this.assignForm.get('ma_i')?.updateValueAndValidity();
      } else {
        this.assignForm.get('ma_i')?.setValue([]);
        // Add 'required' validation back
        this.assignForm.get('ma_i')?.setValidators(Validators.required);
        this.assignForm.get('ma_i')?.updateValueAndValidity();
      }
    }
  }

  onSubmit() {

    if (this.dialogData == "manager") {
      if (this.assignForm.invalid) {
        this.assignForm.markAllAsTouched();
        return;
      }
      let obj = {
        em_i: this.assignForm.value.em_i,
        ma_i: this.assignForm.value.ma_i,
      }

      this.userManagementService.assignEmp(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {

          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }


    if (this.dialogData == "employee") {

      if (this.assignForm.invalid) {
        this.assignForm.markAllAsTouched();
        return;
      }
      let obj = {
        em_i: this.assignForm.value.em_i,
        ma_i: this.assignForm.value.ma_i,
      }

      this.userManagementService.assignManager(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {

          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  onCancel() {
    this.dialogRef.close()
  }

  getFilteredList(item: any): any[] {
    if (!item.arr) return [];
    if (!item.searchText) return item.arr;


    console.log(item.arr)

    const searchText = item.searchText.toLowerCase();

    return item.arr.filter(dep => {
      const filterVal = dep[item.filter_value]?.toString().toLowerCase().includes(searchText);
      const fullName = item.nameFields?.map(f => dep[f] || '').join(' ').toLowerCase().includes(searchText);
      return filterVal || fullName;
    });
  }


}
